export default __webpack_public_path__ + "static/media/1_pouchOfGems.9a7d4e61.png";